import { useKnowledgeBaseDeleteKnowledgeRemoveDeleteMutation } from '@shared/api';

export const useDeleteKnowledgeBase = (onError?: () => void) => {
  const [deleteKnowledgeBaseMutation, { isLoading }] =
    useKnowledgeBaseDeleteKnowledgeRemoveDeleteMutation();
  const deleteKnowledgeBase = async (knowledgeBaseId: number) => {
    try {
      await deleteKnowledgeBaseMutation({
        knowledgeBaseId,
      }).unwrap();
    } catch {
      onError?.();

      throw new Error();
    }
  };

  return { deleteKnowledgeBase, isLoading };
};
